import React from 'react';

export const themes = {
  dark:{
    color: 'white',
    background: 'black',
    padding: '5px',
    menuBack: '#030302',
    name: "dark",
  },
  light:{
    background: 'white',
    color: 'black',
    padding: '5px',
    menuBack: '#F4F5FF',
    name: 'light',
  }
};

const ThemeConstext = React.createContext(themes.dark);

export default ThemeConstext